import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { ApiServicesService } from './services/api-services.service';
import { UserDetailsService } from './services/user-details.service';

import { bootstrapApplication } from '@angular/platform-browser';
import {  HTTP_INTERCEPTORS } from '@angular/common/http';
import { SnackbarService } from './services/snackbar.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [HttpClientModule, RouterOutlet, HeaderComponent, CommonModule, FooterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

 
})
export class AppComponent implements OnInit {
  title = 'frontend';

  constructor(
    private apiService: ApiServicesService,
    private userdetails: UserDetailsService,
    private router: Router,
    private snackbarService:SnackbarService
  ) {}

  userProfile: any;
  public isUserlogined: boolean = false;
  public apiTriggered: boolean = false;

  ngOnInit(): void {
    const isBrowser =
      typeof window !== 'undefined' && typeof localStorage !== 'undefined';
    if (isBrowser) {
      const encryptedData = localStorage.getItem('encryptedUserData');
      if (encryptedData) {
        const decryptedData = this.apiService.decryptData(encryptedData);
        this.isUserlogined = true;
        if (decryptedData && decryptedData.user) {
          const dynamicUsername = decryptedData.user.username;
          if (location.pathname.includes('my-profile')) {
            this.apiService.getUserProfile(dynamicUsername).subscribe({
              next: (response) => {
                this.userProfile = response;
                if (this.userProfile && this.userProfile.user) {
                  const encryptedData = this.apiService.encryptData(response);
                  localStorage.setItem('encryptedUserData', encryptedData);
                  this.userdetails.Gotuserdetails(this.userProfile);
                  this.apiTriggered = true;
                }
              },
              error: (err) => {
      
                this.snackbarService.openCustomSnackbar(
                  {
                    icon: false,
                    message: err.error.message,
                    className: 'failed',
                  }
                );
              },
            });
          } else {
            this.apiTriggered = true;
          }
        }
        // this.apiService.getDropdowndata().subscribe({
        //   next: (response: any) => {
        //     this.userdetails.dropDownData.next(response.data);
        //     localStorage.setItem('dropdownData', JSON.stringify(response.data));
        //   },
        //   error: (err) => {},
        // });
      } else {
        this.apiTriggered = true;
      }
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }


  isButtonVisible = false;

  // Listen to window scroll events to toggle the button's visibility
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isButtonVisible = window.scrollY > 300; // Show button after scrolling 300px
  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}


